export default Object.freeze({
  // SAMPLE_DELETE: 'SAMPLE_DELETE',
});
